module.exports = __webpack_public_path__ + "static/media/kellyLewis.62dc9e66.jpg";